"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Shirt, Laptop, BookOpen } from "lucide-react";
const reviews = [{
  author: "Sarah Jenkins",
  quote: "Dustin's devotionals have become a cornerstone of my morning routine. They offer a rare depth that truly nourishes the soul.",
  position: "Ministry Leader",
  category: "Devotionals",
  icon: BookOpen,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679939/img/reader_sarah_jenkins.png"
}, {
  author: "David Thompson",
  quote: "The 'Rooted in Purpose' study guide transformed how our small group engages with Scripture. It is both practical and profound.",
  position: "Small Group Coordinator",
  category: "Bible Study",
  icon: BookOpen,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679939/img/reader_david_thompson.png"
}, {
  author: "Rebecca Miller",
  quote: "A modern voice for timeless truths. These books are beautifully written and essential for anyone seeking a deeper walk with God.",
  position: "Theology Student",
  category: "Resources",
  icon: BookOpen,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679939/img/reader_rebecca_miller.png"
}];
export default function GlobalReaderReviews() {
  return;
}